import(/* webpackMode: "eager", webpackExports: ["AboutPage"] */ "/vercel/path0/apps/web/src/modules/public/AboutPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useSession"] */ "/vercel/path0/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientResourceProvider"] */ "/vercel/path0/shared/config/src/components/ClientResourceProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResourceConfigProvider"] */ "/vercel/path0/shared/config/src/components/ResourceConfigProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResourceConfigContext"] */ "/vercel/path0/shared/config/src/contexts/ResourceConfigContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConfiguredComponent"] */ "/vercel/path0/shared/config/src/functions/ConfiguredComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useResourceConfig"] */ "/vercel/path0/shared/config/src/hooks/useResourceConfig.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/httpService/src/utils/useAbortController.ts");
